import { render, staticRenderFns } from "./DeadChart.vue?vue&type=template&id=da9b6ca8"
import script from "./DeadChart.vue?vue&type=script&lang=js"
export * from "./DeadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports